(function () {
  // Mobile navigation
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-menu-toggle]');
    if (!t) return;
    var nav = document.getElementById('MobileNav');
    if (!nav) return;
    var open = nav.classList.toggle('is-open');
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  // Reveal on scroll
  function initReveal() {
    var els = document.querySelectorAll('.reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }
  document.addEventListener('DOMContentLoaded', initReveal);
  document.addEventListener('shopify:section:load', initReveal);

  // Product gallery thumbnails
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-thumb]');
    if (!btn) return;
    var gallery = btn.closest('[data-gallery]');
    var main = gallery.querySelector('.js-main-image');
    main.src = btn.dataset.src;
    main.srcset = btn.dataset.srcset || '';
    main.alt = btn.dataset.alt || '';
    gallery.querySelectorAll('[data-thumb]').forEach(function (b) { b.setAttribute('aria-current', b === btn ? 'true' : 'false'); });
  });

  // Variant picker
  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return (format || '${{amount}}').replace(/\{\{\s*\w+\s*\}\}/, withCommas);
  }

  document.addEventListener('change', function (e) {
    var picker = e.target.closest('[data-variant-picker]');
    if (!picker) return;
    var section = picker.closest('[data-product-section]');
    var data = JSON.parse(section.querySelector('[data-variants-json]').textContent);
    var selected = Array.prototype.map.call(picker.querySelectorAll('fieldset'), function (fs) {
      var checked = fs.querySelector('input:checked');
      return checked ? checked.value : null;
    });
    var variant = data.variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selected[i]; });
    });
    var idInput = section.querySelector('[data-variant-id]');
    var addBtn = section.querySelector('[data-add-button]');
    var priceEl = section.querySelector('[data-price]');
    var compareEl = section.querySelector('[data-compare-price]');
    if (!variant) {
      addBtn.disabled = true;
      addBtn.textContent = addBtn.dataset.unavailable;
      return;
    }
    idInput.value = variant.id;
    addBtn.disabled = !variant.available;
    addBtn.textContent = variant.available ? addBtn.dataset.add : addBtn.dataset.soldout;
    priceEl.textContent = money(variant.price, data.money_format);
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = money(variant.compare_at_price, data.money_format);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }
    if (variant.featured_image) {
      var main = section.querySelector('.js-main-image');
      if (main) { main.src = variant.featured_image; main.srcset = ''; }
    }
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  });
})();
